export const PingCookie = 'token';
export const InternalCookie = 'auth._token.local';
export const AuthTokenCookie = 'auth-token';

function _useCookie(name: string) {
  return useCookie(name, { path: '/' });
}

export const internalCookie = _useCookie(InternalCookie);
export const pingCookie = _useCookie(PingCookie);
export const authTokenCookie = _useCookie(AuthTokenCookie);
